import { Loader } from 'components/loader';
import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge'

interface IButtonProps {
  children: ReactNode;
  className?: string;
  loading?: boolean;
  loaderSize?: number;
  [x: string]: any;
}

const Button = ({ className="" , children, loading = false, loaderSize = 40, ...rest}: IButtonProps) => {
  return (
    <button
      type="button"
      className={twMerge(
        "button",
        className
      )}
      {...rest}
    >
      <div className="flex items-center justify-center max-h-full bg-inherit">
        {children}
        {loading ? (
          <div className="absolute w-full h-full z-[2] flex items-center justify-center bg-inherit">
            <Loader className="h-[80%] w-auto" />
          </div>
        ) : <></>}
      </div>
    </button>
  )  
}

export default Button;